import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ConfigurationService } from './app/core/services/configuration.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

ConfigurationService.loadConfig().then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
});
